import React, { useState, useEffect } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import SearchBar from "../../../../components/SearchBar";
import Pagination from "../../../../components/Pagination";
import ExportToExcel from "../../../../components/ExportToExcel";
import moment from "moment";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";


const ProjectStatusReport = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [myProjectData, setMyProjectData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectOpt, setProjectOpt] = useState([]);
  const [createdOpt, setCreatedOpt] = useState([]);
  const [projectTypesOpt, setProjectTypesOpt] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState(null);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState(null);
  const [selectedProjectType, setSelectedProjectType] = useState(null);
  const [projectDataDetail, setProjectDataDetails] = useState("");

  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );
  useEffect(() => {
    dispatch(updateNavbarHeading("Project Status Report"));
  }, []);
  // Define all columns with their display text and initial visibility
  const [columns, setColumns] = useState({
    Code: { text: "Code", visible: true },
    Name: { text: "Project", visible: true },
    Client: { text: "Client", visible: true },
    Location: { text: "Location", visible: true },
    CreatedBy: { text: "Created By", visible: true },
    ProjectType: { text: "Project Type", visible: true },
    StartDate: { text: "From Date", visible: true },
    EndDate: { text: "End Date", visible: true },
    TeamSize: { text: "Team Size", visible: true },
    Progress: { text: "Progress (%)", visible: true },
    action: { text: "Action", visible: true },
  });

  const handleProjectModalClose = () => {
    setShowProjectModal(false);
    setSelectedProject(null);
  };
  useEffect(() => {
    fetchProjectData();
  }, []);

  const fetchProjectData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/2?P_ProjectID=&P_CreatedBy=&P_ProjectType`
      );
      SetApiStatus(response?.status);

      if (response.status === 200) {
        const projectData = response?.data?.data;
        setMyProjectData(projectData);
        // Project List
        const ProjectList = response?.data?.projectlist;
        const ProjectOptions = ProjectList.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setProjectOpt(ProjectOptions);
        // Created BY List
        const empList = response?.data?.employee;
        const createdOptions = empList.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setCreatedOpt(createdOptions);
        // Project Type List
        const proList = response?.data?.projectallocationtype;
        const projectTypeOpt = proList.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setProjectTypesOpt(projectTypeOpt);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch My Project. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Project:", error);
    }
  };
  const handleGetData = async () => {
    const projectID = selectedProjects?.value || "";
    const createdBy = selectedCreatedBy?.value || "";
    const projectType = selectedProjectType?.value || "";
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/2?P_ProjectID=${projectID}&P_CreatedBy=${createdBy}&P_ProjectType=${projectType}`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        setMyProjectData(response?.data?.data);
        // Optionally close dropdown
        document.getElementById("excel-btn")?.click(); // closes dropdown
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  // Filter data based on search term
  const filteredData = myProjectData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // Get current items for pagination
  const indexOfLastItem = currentPage * selectedRecordsPerPage;
  const indexOfFirstItem = indexOfLastItem - selectedRecordsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Function to toggle column visibility
  const toggleColumn = (columnKey) => {
    setColumns((prev) => ({
      ...prev,
      [columnKey]: {
        ...prev[columnKey],
        visible: !prev[columnKey].visible,
      },
    }));
  };

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setSelectedRecordsPerPage(newRecordsPerPage);
    setItemsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const handleProjectClick = async (item) => {
    setSelectedProject(item);
    setShowProjectModal(true);

    try {
      const response = await GetServiceCaller(
        `${API_URL}projectstatusdetails/${item.ID}`
      );
      if (response?.status === 200) {
        const data = response?.data?.data;
        setProjectDataDetails(data);

        // setProjectInfoDetails();
      } else {
        console.error(
          "Failed to fetch project status details:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching project status details:", error);
    }
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return moment(dateStr).format("DD-MMM-YYYY");
  };

  const handleReset = () => {
    setSelectedCreatedBy()
    setSelectedProjects()
    fetchProjectData()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="rounded bg-white" id="skill-table-area">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <div className="me-1">
                <SearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              </div>
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
              >
                <div className="btn-group me-2">
                  <button
                    type="button"
                    className="dropdown-toggle skill-button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    id="excel-btn"
                  >
                    <i className="bi bi-funnel-fill"></i>
                  </button>
                  <ul
                    className="dropdown-menu p-2 project-status-filter"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <label className="form-label">Project</label>
                        <Select
                          options={projectOpt}
                          value={selectedProjects || null}
                          onChange={(selected) => setSelectedProjects(selected)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Created By</label>
                        <Select
                          options={createdOpt}
                          value={selectedCreatedBy || null}
                          onChange={(selected) =>
                            setSelectedCreatedBy(selected)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Project Type</label>
                        <Select
                          options={projectTypesOpt}
                          value={selectedProjectType}
                          onChange={(selected) =>
                            setSelectedProjectType(selected)
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="text-end">
                        <button className="custom-btn me-2" onClick={handleReset}>
                          Reset
                        </button>
                        <button className="custom-btn" onClick={handleGetData}>
                          Get Data
                        </button>
                      </div>
                    </div>
                  </ul>
                </div>
              </OverlayTrigger>
            </div>
            <div className="d-flex justify-content-end">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
              >
                <div className="me-1">
                  <ExportToExcel
                    data={currentItems.map((item) => {
                      const visibleItem = {};
                      if (columns.Code.visible)
                        visibleItem["Code"] = item.Code || "";
                      if (columns.Name.visible)
                        visibleItem["Project"] = item.Name || "";
                      if (columns.Client.visible)
                        visibleItem["Client"] = item.Client || "-";
                      if (columns.Location.visible)
                        visibleItem["Location"] = item.Location || "-";
                      if (columns.CreatedBy.visible)
                        visibleItem["Created By"] = item.CreatedBy || "";
                      if (columns.ProjectType.visible)
                        visibleItem["Project Type"] = item.ProjectType || "";
                      if (columns.StartDate.visible)
                        visibleItem["From Date"] = item.StartDate
                          ? moment(item.StartDate).format("DD-MMM-YYYY")
                          : "-";
                      if (columns.EndDate.visible)
                        visibleItem["End Date"] = item.EndDate
                          ? moment(item.EndDate).format("DD-MMM-YYYY")
                          : "-";
                      if (columns.TeamSize.visible)
                        visibleItem["Team Size"] = item.TeamSize || "";
                      if (columns.Progress.visible)
                        visibleItem["Progress (%)"] = item.Progress
                          ? `${item.Progress}%`
                          : "0%";
                      return visibleItem;
                    })}
                    filename={`${ExcelName}.csv`}
                  />
                </div>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
              >
                <div className="btn-group me-2">
                  <button
                    type="button"
                    className="dropdown-toggle skill-button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    id="excel-btn"
                  >
                    <i className="bi bi-list"></i>
                  </button>
                  <ul className="dropdown-menu p-2">
                    <div className="row">
                      <Form.Group>
                        {Object.keys(columns).map((columnKey) => (
                          <Form.Check
                            key={columnKey}
                            type="checkbox"
                            id={`checkbox-${columnKey}`}
                            label={columns[columnKey].text}
                            checked={columns[columnKey].visible}
                            onChange={() => toggleColumn(columnKey)}
                          />
                        ))}
                      </Form.Group>
                    </div>
                  </ul>
                </div>
              </OverlayTrigger>
            </div>
          </div>
          <Table bordered striped hover>
            <thead id="thcolor">
              <tr className="text-center">
                {columns.Code.visible && <th>Code</th>}
                {columns.Name.visible && (
                  <th style={{ width: "180px" }}>Project</th>
                )}
                {columns.Client.visible && <th>Client</th>}
                {columns.Location.visible && <th>Location</th>}
                {columns.CreatedBy.visible && <th>Created By</th>}
                {columns.ProjectType.visible && <th>Project Type</th>}
                {columns.StartDate.visible && <th>From</th>}
                {columns.EndDate.visible && <th>End</th>}
                {columns.TeamSize.visible && <th>Team Size</th>}
                {columns.Progress.visible && <th>Progress (%)</th>}
                {columns.action.visible && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {apiStatus === 200 && currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <tr key={index}>
                    {columns.Code.visible && <td>{item.Code || "-"}</td>}
                    {columns.Name.visible && (
  <td style={{ maxWidth: "180px" }} className="text-primary">
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${index}`}>{item.Name || "-"}</Tooltip>}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: "pointer",
        }}
        onClick={() => handleProjectClick(item)}
      >
        {item.Name || "-"}
      </div>
    </OverlayTrigger>
  </td>
)}

                    {columns.Client.visible && <td>{item.Client || "-"}</td>}
                    {columns.Location.visible && (
                      <td>{item.Location || "-"}</td>
                    )}
                    {columns.CreatedBy.visible && (
                      <td>{item.CreatedBy || "-"}</td>
                    )}
                    {columns.ProjectType.visible && (
                      <td>{item.ProjectType || "-"}</td>
                    )}
                    {columns.StartDate.visible && (
                      <td className="text-center">
                        {item.StartDate
                          ? moment(item.StartDate).format("DD-MMM-YYYY")
                          : "-"}
                      </td>
                    )}
                    {columns.EndDate.visible && (
                      <td className="text-center">
                        {item.EndDate
                          ? moment(item.EndDate).format("DD-MMM-YYYY")
                          : "-"}
                      </td>
                    )}
                    {columns.TeamSize.visible && (
                      <td className="text-center">{item.TeamSize || "-"}</td>
                    )}
                    {columns.Progress.visible && (
                      <td style={{ minWidth: "150px" }}>
                        <div
                          className="progress position-relative"
                          style={{ height: "25px" }}
                        >
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${item.Progress || 0}%` }}
                            aria-valuenow={item.Progress || 0}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                          <span
                            className="position-absolute w-100 text-center"
                            style={{
                              top: "50%",
                              left: "0",
                              transform: "translateY(-50%)",
                              fontWeight: "bold",
                              fontSize: "0.7rem",
                            }}
                          >
                            {item.Progress || 0}%
                          </span>
                        </div>
                      </td>
                    )}
                    {columns.action.visible && (
                      <td className="text-center">
                        <i className="bi bi-envelope-fill"></i>
                      </td>
                    )}
                  </tr>
                ))
              ) : apiStatus === 200 && currentItems.length === 0 ? (
                <tr>
                  <td
                    colSpan={
                      Object.values(columns).filter((col) => col.visible).length
                    }
                    className="text-center text-muted"
                  >
                    No data found
                  </td>
                </tr>
              ) : apiStatus === undefined ? <tr>
                <td
                  colSpan={
                    Object.values(columns).filter((col) => col.visible).length
                  }
                  className="text-center text-muted"
                >
                  <div>
                    <p>
                      <FaSpinner class="spinner" />
                      <br />
                      Loading
                    </p>
                  </div>
                </td>
              </tr> : null}
            </tbody>
          </Table>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <span className="d-flex">
                Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
                {Math.min(
                  currentPage * selectedRecordsPerPage,
                  filteredData.length
                )}{" "}
                of {filteredData.length} <span className="ms-1">results</span>
                <select
                  value={selectedRecordsPerPage}
                  onChange={handleRecordsPerPage}
                  className="mx-2 form-select-sm"
                >
                  {recordsPerPageOption.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div>
              <Pagination
                itemsPerPage={selectedRecordsPerPage}
                totalItems={filteredData.length}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Project Model */}
      {showProjectModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header"style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
                <p style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}>Project Details</p>
                <span className="me-2">
                  <i
                    className="bi bi-x-lg"
                    onClick={handleProjectModalClose}
                    style={{ cursor: "pointer" }}
                  ></i>
                </span>
              </div>
              <div className="modal-body p-0">
                {projectDataDetail?.length > 0 && (
                  <div className="container-fluid">
                    <div className="project-status-card">
                      <div className="row mb-3">
                        <div className="col-md-7">
                          <div className="info-row-status">
                            <div className="info-label-status">Name</div>
                            <div className="info-value-status">
                              {projectDataDetail[0]?.ProjectName || ""}
                            </div>
                          </div>
                          <div className="info-row-status">
                            <div className="info-label-status">Client</div>
                            <div className="info-value-status">
                              {projectDataDetail[0]?.ClientName || ""}
                            </div>
                          </div>
                          <div className="info-row-status">
                            <div className="info-label-status">Technology</div>
                            <div className="info-value-status">
                              {projectDataDetail[0]?.Technology || ""}
                            </div>
                          </div>
                          <div className="info-row-status">
                            <div className="info-label-status">Details</div>
                            <div className="info-value-status">
                              {projectDataDetail[0]?.Details || ""}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="info-row-status">
                            <div className="info-label-status">
                              Project Type
                            </div>
                            <div className="info-value-status">
                              {projectDataDetail[0]?.ProjectType || ""}
                            </div>
                          </div>
                          <div className="info-row-status">
                            <div className="info-label-status">Lead By</div>
                            <div className="info-value-status">
                              {projectDataDetail[0]?.LeadBy || ""}
                            </div>
                          </div>
                          <div className="info-row-status">
                            <div className="info-label-status">Start Date</div>
                            <div className="info-value-status">
                              {formatDate(projectDataDetail[0]?.StartDate)}
                            </div>
                          </div>
                          <div className="info-row-status">
                            <div className="info-label-status">End Date</div>
                            <div className="info-value-status">
                              {formatDate(projectDataDetail[0]?.EndDate)}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="resources-title-status">Resources</div>

                      <div className="table-responsive resource-table">
                        <table className="table table-bordered">
                          <thead>
                            <tr style={{ backgroundColor: "red" }}>
                              <th>Name</th>
                              <th colSpan="2" className="text-center">
                                Allocation
                              </th>
                              <th colSpan="3" className="text-center">
                                Task
                              </th>
                            </tr>
                            <tr>
                              <th></th>
                              <th className="text-center">From Date</th>
                              <th className="text-center">To Date</th>
                              <th className="text-center">Open</th>
                              <th className="text-center">Pending</th>
                              <th className="text-center">Closed</th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectDataDetail.map((res, idx) => (
                              <tr key={idx}>
                                <td>{res.ResourceName}</td>
                                <td className="text-center">
                                  {formatDate(res.ResourceFromDate)}
                                </td>
                                <td className="text-center">
                                  {formatDate(res.ResourceToDate)}
                                </td>
                                <td className="text-center">
                                  {res.ResourceOpeningTask || ""}
                                </td>
                                <td className="text-center">
                                  {res.ResourcePendingTask || ""}
                                </td>
                                <td className="text-center">
                                  {res.ResourceClosedTask || ""}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={parseInt(
                            projectDataDetail[0]?.Progress || 0
                          )}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{
                            width: `${projectDataDetail[0]?.Progress || 0}%`,
                          }}
                        >
                          {projectDataDetail[0]?.Progress || 0} %
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="text-end pb-2">
                <button
                  className="cancel-btn me-2"
                  onClick={handleProjectModalClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectStatusReport;
